import '../../../filtersGrid.scss';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useMediaQuery } from '@mui/material';
import SearchButton from '../../../../components/SearchButton/SearchButton';
import ProvinciasModal from '../../../provincias/provinciasModal/provinciasModal';
import DepartamentosModal from '../../../departamentos/departamentosModal/departamentosModal';

Modal.setAppElement('#root');

const FiltersGrid = ({
  searchInputRef,
  searchTerm,
  onSearch,
  onClose,
  searchIDFilter,
  searchDescFilter,
  searchIDSecondFilter,
  searchDescSecondFilter,
  setSearchTerm,
  setSearchIDFilter,
  setSearchDescFilter,
  setSearchIDSecondFilter,
  setSearchDescSecondFilter,
  idSelectorProv,
  idSelectorDepa }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    if (searchIDFilter && !idSelectorProv && !idSelectorDepa) {
    }
  }, [searchIDFilter, idSelectorProv, idSelectorDepa]);


  useEffect(() => {
    if (!isSmallScreen) {
      setIsModalOpen(false); // Cierra el modal al cambiar a pantallas grandes
    }
  }, [isSmallScreen]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleClearFilters = () => {
    setSearchTerm?.("");
    setSearchIDFilter?.("");
    setSearchDescFilter?.("");
    setSearchIDSecondFilter?.("");
    setSearchDescSecondFilter?.("");
  };

  const renderModals = () => (
    <>
      {!idSelectorProv &&
        <ProvinciasModal
          handleChange={setSearchIDFilter}
          handleDescChange={setSearchDescFilter}
          handleDepaChange={setSearchIDSecondFilter}
          descSelected={searchDescFilter}
        />
      }
      {((!idSelectorProv && !idSelectorDepa) && searchIDFilter) &&
        <DepartamentosModal
          handleChange={setSearchIDSecondFilter}
          handleDescChange={setSearchDescSecondFilter}
          idSelectorProv={searchIDFilter}
          descSelected={searchDescSecondFilter}
        />
      }
    </>
  );

  return (
    <div className="filterContainer">
      {isSmallScreen ? (
        <>
          <button className="filterButton" onClick={handleOpenModal}>
            Filtros De Búsqueda
          </button>

          <Modal
            isOpen={isModalOpen}
            onRequestClose={handleCloseModal}
            contentLabel="Seleccionar Filtros"
            className="modalScreen"
            overlayClassName="overlayScreen"
          >
            <h2>Filtros de Búsqueda</h2>
            <div className="modalContent">
              <SearchButton
                searchInputRef={searchInputRef}
                searchTerm={searchTerm} // Muestra el valor del filtro actual
                onSearch={onSearch}
                onChange={setSearchTerm}
                onClose={() => {
                  setSearchDescFilter(""); // Limpia el filtro
                  onClose();
                }}
                tipo={0}
              />
              {renderModals()}
            </div>
            <div className="actionsRow">
              <button
                type="button"
                className="clearFiltersButton"
                onClick={handleClearFilters}
              >
                Limpiar filtros
              </button>
            </div>
            <button className="modalCloseButton" onClick={handleCloseModal}>
              ❌
            </button>
          </Modal>
        </>
      ) : (
        <>
          <div className="searchContainer">
            <div className="row">
              <SearchButton
                searchInputRef={searchInputRef}
                searchTerm={searchTerm}
                onChange={setSearchTerm}
                onSearch={onSearch}
                onClose={() => {
                  setSearchDescFilter(""); // Limpia el filtro
                  onClose();
                }}
                tipo={0}
              />
              {renderModals()}
            </div>

          </div>
          <div className="actionsRow">
            <button
              type="button"
              className="clearFiltersButton"
              onClick={handleClearFilters}
            >
              Limpiar filtros
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default FiltersGrid;
